import React from "react";
import { Link } from "react-router-dom";

const FinalLinks = () => {
    return (
        <div className="final-links">
            <div className="content">
                <div className="text-center">
                    {/* <Link to="/mba-program" className="btn btn--primary">
                        آشنایی بیشتر با دوره
                    </Link> */}

                    <h3 to="" className="like-btn btn--primary">
                        آشنایی بیشتر با دوره
                    </h3>
                </div>
                <div className="row center-xs">
                    <div className="col-xs-6 col-sm-3 col-md-2">
                        {/* <Link to="/mba-program">
                            <img
                                src="/images/home-link-icon-1.svg"
                                className="link-icon"
                                alt="icon-link"
                            />
                            <h5 className="link-title">جزئیات دوره</h5>
                        </Link> */}

                        <Link to="/mba-program/advantages">
                            <img
                                src="/images/home-link-icon-1.svg"
                                className="link-icon"
                                alt="icon-link"
                            />
                            <h5 className="link-title">جزئیات دوره</h5>
                        </Link>
                    </div>
                    <div className="col-xs-6 col-sm-3 col-md-2">
                        <Link to="/faq">
                            <img
                                src="/images/home-link-icon-2.svg"
                                className="link-icon"
                                alt="icon-link"
                            />
                            <h5 className="link-title">سوالات متداول</h5>
                        </Link>
                    </div>
                    {/*<div className="col-xs-6 col-sm-3 col-md-2">*/}
                    {/*    <Link to="/" onClick={e => e.preventDefault()}>*/}
                    {/*        <img*/}
                    {/*            src="/images/home-link-icon-3.svg"*/}
                    {/*            className="link-icon"*/}
                    {/*            alt="icon-link"*/}
                    {/*        />*/}
                    {/*        <h5 className="link-title">پشتیبانی آنلاین</h5>*/}
                    {/*    </Link>*/}
                    {/*</div>*/}
                    <div className="col-xs-6 col-sm-3 col-md-2">
                        <a href="tel:+982166089773">
                            <img
                                src="/images/home-link-icon-4.svg"
                                className="link-icon"
                                alt="icon-link"
                            />
                            <h5 className="link-title">۰۲۱۶۶۰۸۹۷۷۳</h5>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FinalLinks;
